<div class="notification-bar" *ngIf="active && content" [ngStyle]="{ backgroundColor: backgroundColor }">
    <div class="container">
        <div class="content">
            <div
                class="kk-rte kk-rte_tight"
                [innerHTML]="content | safe: 'html'"
                appInterceptLinks
                [ngStyle]="{ color: textColor }"
            ></div>
            <button [ngStyle]="{ color: textColor }" (click)="onCloseNotification()">
                <app-svg-icon iconName="close"></app-svg-icon>
            </button>
        </div>
    </div>
</div>
